import type { ColorType } from '@shared/types';

export interface ColorPair {
  base: number;
  light: number;
  dark: number;
  rgba: (a: number) => string;
}

export const NEON_COLORS: Record<ColorType, ColorPair> = {
  red: {
    base: 0xe63946,
    light: 0xff8a92,
    dark: 0x8a1a22,
    rgba: (a) => `rgba(230, 57, 70, ${a})`,
  },
  blue: {
    base: 0x3b82f6,
    light: 0x7ea9f7,
    dark: 0x1d4ed8,
    rgba: (a) => `rgba(59, 130, 246, ${a})`,
  },
  yellow: {
    base: 0xf4c724,
    light: 0xffe066,
    dark: 0xa07c00,
    rgba: (a) => `rgba(244, 199, 36, ${a})`,
  },
  purple: {
    base: 0x9b5de5,
    light: 0xc084fc,
    dark: 0x5b21b6,
    rgba: (a) => `rgba(155, 93, 229, ${a})`,
  },
};

export const CYAN = 0x22d3ee;
export const INK = 0xf5f3ff;
export const NAVY = 0x1e1b4b;
export const NAVY_DEEP = 0x0e0b2e;
